import { Component, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GroupQuestion } from '../models/group-question';
import { TutorizationQuestionService } from '../services/tutorization-question.service';
import { ListComponent, PopUpService } from 'app/core';

@Component({
  selector: 'lms-mars1-questions-list',
  templateUrl: './mars1-questions-list.component.html',
  styleUrls: ['./mars1-questions-list.component.scss']
})
export class Mars1QuestionsListComponent implements OnChanges {
  @Input() listId: string;
  @Input() options: any;
  @Output() listUpdated: EventEmitter<any> = new EventEmitter<any>();
  public defaultOptions: any = { sort: 'name', elementsName: 'questions.label' };
  public listOptions: any;
  @ViewChild(ListComponent, { static: false }) public listComponent: ListComponent;

  questions: GroupQuestion[];

  constructor(
    public groupQuestionsService: TutorizationQuestionService,
    public router: Router,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  ngOnChanges() {
    this.listOptions = Object.assign({}, this.defaultOptions, this.options);
  }

  setCollection(collection) {
    this.questions = collection.filter((question) => !question.questionId);
    this.listUpdated.emit(collection);
  }

  deleteQuestion(question) {
    this.popupService
      .confirmDelete({
        title: this.translate.instant('customizations.documents.questions.confirmDelete'),
        text: this.translate.instant('customizations.documents.questions.deleteMessage')
      })
      .then(() => this.groupQuestionsService.delete(question.id))
      .then(() => this.listComponent.fetch())
      .catch((err) => {
        if (err !== 'cancel') {
          this.popupService.showError({
            title: this.translate.instant('questions.deleteError'),
            text: err.serverMessage
          });
        }
      });
  }
}
